import React from 'react';
import {greyishBlue100} from "assets/jss/main";

function Divider(props) {
    return (
        <div style={{
            width: '100%',
            borderBottom: `1px solid ${greyishBlue100}`
        }}></div>
    );
}

export default Divider;
